module.exports = __webpack_public_path__ + "img/icon4.b1540e94.svg";